'use strict';

import validationBubble from '../Utilidades/validationBubbleRemover';

import perfil from './Perfil/perfilCtrl';
import certificados from './Certificados/certificadosCtrl';
import impuestos from './Impuestos/impuestosCtrl';
import descuentos from './Descuentos/descuentosCtrl';
//import correos from './Correos/correosCtrl';
import logo from './Logo/logoCtrl';
import usuariospermisos from './Usuarios/usuariosCtrl';
import cobros from './Cobros/cobrosCtrl';

export default angular.module('contartemx.preferencias', [
    'contartemx.preferencias.perfil',
    'contartemx.preferencias.certificados',
    'contartemx.preferencias.impuestos',
    'contartemx.preferencias.descuentos',
    //'contartemx.preferencias.correos',
    'contartemx.preferencias.logo',
    'contartemx.preferencias.usuariospermisos',
    //'contartemx.preferencias.etiquetas',
    'contartemx.preferencias.cobros',
    'floatingDiv',
    'ui.router'
])

    .config(($stateProvider) => {

      $stateProvider.state('preferencias', {
        url: '/Preferencias',
        abstract: true,
        views: {
          '': {
            template: require('../../../../app/views/Preferencias/Preferencias_main.html'),
            controller: 'PreferenciasCtrl'
          }
        },
        resolve: {
          authorize: ['authorization', authorization => authorization.authorize()],
        },
        data: { roles: ['Preferencias'] }
      })
        .state('preferencias.perfil', {
          url: '/Perfil',
          views:
            {
              'main': {
                template: require('../../../../app/views/Preferencias/Perfil/Perfil_main.html'),
                controller: 'PerfilCtrl'
              }
            },
          data: { roles: ['Preferencias_Perfil'] }
        })
        .state('preferencias.certificados', {
          url: '/Certificados',
          views:
            {
              'main': {
                template: require('../../../../app/views/Preferencias/Certificados/Certificados_main.html'),
                controller: 'CertificadosCtrl'
              }
            },
          data: { roles: ['Preferencias_Certificados'] }
        })
        .state('preferencias.certificados.crear-editar', {
          url: '/:crearEditar/:cveCertificado',
          views: {
            '': {
              template: require('../../../../app/views/Preferencias/Certificados/Certificado_modal.html'),
              controller: 'CertificadoNuevoCtrl'
            }
          }
          })
            .state('preferencias.impuestos', {
                url: '/Impuestos',
                views:
                {
                    'main': {
                        template: require('../../../../app/views/Preferencias/Impuestos/Impuestos_main.html'),
                        controller: 'ImpuestosCtrl'
                    }
                },
                data: { roles: ['Preferencias_Impuestos'] }
            })
            .state('preferencias.descuentos', {
                url: '/Descuentos',
                views:
                {
                    'main': {
                        template: require('../../../../app/views/Preferencias/Descuentos/Descuentos_main.html'),
                        controller: 'DescuentosCtrl'
                    }
                },
                data: { roles: ['Preferencias_Descuentos'] }
            })
            .state('preferencias.logo', {
                url: '/Logo',
                views:
                {
                    'main': {
                        template: require('../../../../app/views/Preferencias/Logo/Logo_main.html'),
                        controller: 'LogoCtrl'
                    }
                },
                data: { roles: ['Preferencias_Logo'] }
            })
            /*
                .state('preferencias.correos', {
                    url: '/Correos',
                    views:
                    {
                        'main':{
                    template: require('../../../../app/views/Preferencias/Correos/Correos_main.html'),
                            controller: 'CorreosCtrl'
                        }
                    }
                })*/
            .state('preferencias.usuariospermisos', {
                url: '/Usuarios',
                views:
                {
                    'main': {
                        template: require('../../../../app/views/Preferencias/Usuarios/Usuarios_main.html'),
                        controller: 'UsuariosCtrl'
                    }
                },
                data: { roles: ['Administracion_Cuentas'] }
            })
            .state('preferencias.etiquetas', {
                url: '/Etiquetas',
                redirectTo: 'preferencias.perfil'
            })
            .state('preferencias.cobros', {
                url: '/Cobros',
                views:
                {
                    'main': {
                        template: require('../../../../app/views/Preferencias/Cobros/Cobros_main.html'),
                        controller: 'PrefCobrosCtrl'
                    }
                },
                data: { roles: ['Preferencias_Cobros'] }
            })
          .state('preferencias.suscripcion', {
              url: '/Suscripcion',
              views:
              {
                'main': {
                  template: require('../../../../app/views/Cuenta/Administrar_Cuenta.html'),
                  controller: 'AdministrarCuentaCtrl'
                }
              },
              //data: { roles: ['Preferencias_Cobros'] }
            });

    })
    .controller('PreferenciasCtrl', () => {
    });
